//约船管理
export default [
  {
    path: "/boat/boatManage",
    component: () => import("../pages/boat/boatManage.vue"),
    name: "boatManage",
    title: "船只管理",
    meta: {
      title: '船只管理',
    }
  },
  {
    path: "/boat/boatCategoryManage",
    component: () => import("../pages/boat/boatCategoryManage.vue"),
    name: "boatCategoryManage",
    title: "船型管理",
    meta: {
      title: '船型管理',
    }
  },
  {
    path: "/boat/boatPlaceManage",
    component: () => import("../pages/boat/boatPlaceManage.vue"),
    name: "boatPlaceManage",
    title: "码头管理",
    meta: {
      title: '码头管理',
    }
  },
  {
    path: "/boat/boatUserManage",
    component: () => import("../pages/boat/boatUserManage.vue"),
    name: "boatUserManage",
    title: "船员管理",
    meta: {
      title: '船员管理',
    }
  },
  {
    path: "/boat/boatOrderManage",
    component: () => import("../pages/boat/boatOrderManage.vue"),
    name: "boatOrderManage",
    title: "约船订单管理",
    meta: {
      title: '约船订单管理',
    }
  },
]
